// Place this at: frontend/src/config/config.js
import axios from 'axios';
import { supabase } from '../supabaseClient';

const getApiBaseUrl = () => {
    if (process.env.NODE_ENV === 'production') {
      return 'https://yemberzal-app-28481d1d0b39.herokuapp.com/api';
    }
    return 'http://127.0.0.1:8000/api';
  };
  
  const apiConfig = {
    baseURL: getApiBaseUrl(),
    headers: {
      'Content-Type': 'application/json',
    }
  };
  
  // If using axios
  const apiClient = axios.create(apiConfig);
  
  // SECURITY: Add Supabase auth token to all requests
  apiClient.interceptors.request.use(async (config) => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.access_token) {
        config.headers.Authorization = `Bearer ${session.access_token}`;
      }
    } catch (error) {
      console.error('Error getting auth session:', error);
    }
    return config;
  });
  
  export default apiClient;